// @generated by protoc-gen-es v1.10.0
// @generated from file omnios/v1/metal.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Struct, Timestamp } from "@bufbuild/protobuf";
import { PageRequest, PageResponse } from "./common_pb.js";

/**
 * @generated from enum omnios.v1.MetalShape
 */
export const MetalShape = /*@__PURE__*/ proto3.makeEnum(
  "omnios.v1.MetalShape",
  [
    {no: 0, name: "METAL_SHAPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "METAL_SHAPE_ROUND_BAR", localName: "ROUND_BAR"},
    {no: 2, name: "METAL_SHAPE_SQUARE_BAR", localName: "SQUARE_BAR"},
    {no: 3, name: "METAL_SHAPE_FLAT_BAR", localName: "FLAT_BAR"},
    {no: 4, name: "METAL_SHAPE_HEX_BAR", localName: "HEX_BAR"},
    {no: 5, name: "METAL_SHAPE_ROUND_PIPE", localName: "ROUND_PIPE"},
    {no: 6, name: "METAL_SHAPE_SQUARE_PIPE", localName: "SQUARE_PIPE"},
    {no: 7, name: "METAL_SHAPE_RECT_PIPE", localName: "RECT_PIPE"},
    {no: 8, name: "METAL_SHAPE_SHEET", localName: "SHEET"},
    {no: 9, name: "METAL_SHAPE_REBAR", localName: "REBAR"},
    {no: 10, name: "METAL_SHAPE_WIRE", localName: "WIRE"},
    {no: 11, name: "METAL_SHAPE_L_ANGLE", localName: "L_ANGLE"},
    {no: 12, name: "METAL_SHAPE_CHANNEL", localName: "CHANNEL"},
    {no: 13, name: "METAL_SHAPE_I_BEAM", localName: "I_BEAM"},
    {no: 14, name: "METAL_SHAPE_T_PROFILE", localName: "T_PROFILE"},
    {no: 15, name: "METAL_SHAPE_WIRE_MESH", localName: "WIRE_MESH"},
  ],
);

/**
 * @generated from enum omnios.v1.MetalCoating
 */
export const MetalCoating = /*@__PURE__*/ proto3.makeEnum(
  "omnios.v1.MetalCoating",
  [
    {no: 0, name: "METAL_COATING_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "METAL_COATING_NONE", localName: "NONE"},
    {no: 2, name: "METAL_COATING_HOT_DIP_GALVANIZED", localName: "HOT_DIP_GALVANIZED"},
    {no: 3, name: "METAL_COATING_ELECTRO_GALVANIZED", localName: "ELECTRO_GALVANIZED"},
    {no: 4, name: "METAL_COATING_POLYMER", localName: "POLYMER"},
  ],
);

/**
 * @generated from enum omnios.v1.StandardType
 */
export const StandardType = /*@__PURE__*/ proto3.makeEnum(
  "omnios.v1.StandardType",
  [
    {no: 0, name: "STANDARD_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "STANDARD_TYPE_GOST", localName: "GOST"},
    {no: 2, name: "STANDARD_TYPE_TU", localName: "TU"},
  ],
);

/**
 * @generated from enum omnios.v1.WeightToleranceProto
 */
export const WeightToleranceProto = /*@__PURE__*/ proto3.makeEnum(
  "omnios.v1.WeightToleranceProto",
  [
    {no: 0, name: "WEIGHT_TOLERANCE_UNSPECIFIED"},
    {no: 1, name: "WEIGHT_TOLERANCE_NORMAL"},
    {no: 2, name: "WEIGHT_TOLERANCE_INCREASED"},
  ],
);

/**
 * @generated from enum omnios.v1.MetalPriceUnit
 */
export const MetalPriceUnit = /*@__PURE__*/ proto3.makeEnum(
  "omnios.v1.MetalPriceUnit",
  [
    {no: 0, name: "METAL_PRICE_UNIT_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "METAL_PRICE_UNIT_PER_TONNE", localName: "PER_TONNE"},
    {no: 2, name: "METAL_PRICE_UNIT_PER_KG", localName: "PER_KG"},
    {no: 3, name: "METAL_PRICE_UNIT_PER_METRE", localName: "PER_METRE"},
    {no: 4, name: "METAL_PRICE_UNIT_PER_PIECE", localName: "PER_PIECE"},
    {no: 5, name: "METAL_PRICE_UNIT_PER_M2", localName: "PER_M2"},
  ],
);

/**
 * @generated from message omnios.v1.MetalSpec
 */
export const MetalSpec = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.MetalSpec",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "shape", kind: "enum", T: proto3.getEnumType(MetalShape) },
    { no: 5, name: "dimensions", kind: "message", T: Struct },
    { no: 6, name: "metal", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "steel_grade", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "density_gcm3", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "coating", kind: "enum", T: proto3.getEnumType(MetalCoating) },
    { no: 10, name: "standard_type", kind: "enum", T: proto3.getEnumType(StandardType) },
    { no: 11, name: "gost_standard_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "tolerance", kind: "enum", T: proto3.getEnumType(WeightToleranceProto) },
    { no: 20, name: "linear_density_kg_per_m", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 21, name: "weight_per_piece_kg", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 22, name: "weight_per_m2_kg", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 23, name: "standard_length_mm", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 30, name: "tn_ved_code_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 40, name: "created_at", kind: "message", T: Timestamp },
    { no: 41, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.MetalCertificate
 */
export const MetalCertificate = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.MetalCertificate",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "certificate_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "heat_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "batch_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "producer_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "producer_country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "tensile_strength_mpa", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 11, name: "yield_strength_mpa", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 12, name: "elongation_pct", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 13, name: "impact_strength_kj_m2", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 14, name: "chemical_composition", kind: "message", T: Struct },
    { no: 15, name: "document_media_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "issue_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "certification_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 40, name: "created_at", kind: "message", T: Timestamp },
    { no: 41, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.MetalCuttingRate
 */
export const MetalCuttingRate = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.MetalCuttingRate",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "shape", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "min_thickness_mm", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "max_thickness_mm", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "rate_per_cut_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "rate_per_metre_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "kerf_mm", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 10, name: "is_active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.SortamentEntry
 */
export const SortamentEntry = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SortamentEntry",
  () => [
    { no: 1, name: "dimensions", kind: "message", T: Struct },
    { no: 2, name: "mass_per_m", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "area_cm2", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "gost", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CalculateWeightRequest
 */
export const CalculateWeightRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CalculateWeightRequest",
  () => [
    { no: 1, name: "shape", kind: "enum", T: proto3.getEnumType(MetalShape) },
    { no: 2, name: "dimensions", kind: "message", T: Struct },
    { no: 3, name: "metal", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "density_gcm3", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "coating", kind: "enum", T: proto3.getEnumType(MetalCoating) },
    { no: 10, name: "length_mm", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, oneof: "goal" },
    { no: 11, name: "weight_kg", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, oneof: "goal" },
    { no: 20, name: "temperature_c", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message omnios.v1.CalculateWeightResponse
 */
export const CalculateWeightResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CalculateWeightResponse",
  () => [
    { no: 1, name: "result_value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "result_unit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "linear_density_kg_per_m", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "tolerance_min", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "tolerance_max", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message omnios.v1.CalculateCuttingRequest
 */
export const CalculateCuttingRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CalculateCuttingRequest",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "requested_length_mm", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "count", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "standard_length_mm", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "kerf_mm", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message omnios.v1.CalculateCuttingResponse
 */
export const CalculateCuttingResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CalculateCuttingResponse",
  () => [
    { no: 1, name: "pieces_per_bar", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "waste_per_bar_mm", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "waste_coefficient", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "total_bars_needed", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 5, name: "total_pieces", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 6, name: "total_waste_kg", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "cutting_cost_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ConvertPriceRequest
 */
export const ConvertPriceRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ConvertPriceRequest",
  () => [
    { no: 1, name: "value_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "from_unit", kind: "enum", T: proto3.getEnumType(MetalPriceUnit) },
    { no: 3, name: "to_unit", kind: "enum", T: proto3.getEnumType(MetalPriceUnit) },
    { no: 4, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "linear_density_kg_m", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 11, name: "weight_per_piece_kg", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 12, name: "weight_per_m2_kg", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message omnios.v1.ConvertPriceResponse
 */
export const ConvertPriceResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ConvertPriceResponse",
  () => [
    { no: 1, name: "converted_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "factor", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message omnios.v1.GetSortamentRequest
 */
export const GetSortamentRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetSortamentRequest",
  () => [
    { no: 1, name: "shape", kind: "enum", T: proto3.getEnumType(MetalShape) },
  ],
);

/**
 * @generated from message omnios.v1.GetSortamentResponse
 */
export const GetSortamentResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetSortamentResponse",
  () => [
    { no: 1, name: "entries", kind: "message", T: SortamentEntry, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.GetMetalSpecRequest
 */
export const GetMetalSpecRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetMetalSpecRequest",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.SetMetalSpecRequest
 */
export const SetMetalSpecRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SetMetalSpecRequest",
  () => [
    { no: 1, name: "spec", kind: "message", T: MetalSpec },
  ],
);

/**
 * @generated from message omnios.v1.ListMetalSpecsRequest
 */
export const ListMetalSpecsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListMetalSpecsRequest",
  () => [
    { no: 1, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "shape_filter", kind: "enum", T: proto3.getEnumType(MetalShape) },
    { no: 3, name: "steel_grade_filter", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "page", kind: "message", T: PageRequest },
  ],
);

/**
 * @generated from message omnios.v1.ListMetalSpecsResponse
 */
export const ListMetalSpecsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListMetalSpecsResponse",
  () => [
    { no: 1, name: "specs", kind: "message", T: MetalSpec, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.CreateMetalCertificateRequest
 */
export const CreateMetalCertificateRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateMetalCertificateRequest",
  () => [
    { no: 1, name: "certificate", kind: "message", T: MetalCertificate },
  ],
);

/**
 * @generated from message omnios.v1.ListMetalCertificatesRequest
 */
export const ListMetalCertificatesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListMetalCertificatesRequest",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "page", kind: "message", T: PageRequest },
  ],
);

/**
 * @generated from message omnios.v1.ListMetalCertificatesResponse
 */
export const ListMetalCertificatesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListMetalCertificatesResponse",
  () => [
    { no: 1, name: "certificates", kind: "message", T: MetalCertificate, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.GetCuttingRatesRequest
 */
export const GetCuttingRatesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetCuttingRatesRequest",
  [],
);

/**
 * @generated from message omnios.v1.GetCuttingRatesResponse
 */
export const GetCuttingRatesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetCuttingRatesResponse",
  () => [
    { no: 1, name: "rates", kind: "message", T: MetalCuttingRate, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.SetCuttingRatesRequest
 */
export const SetCuttingRatesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SetCuttingRatesRequest",
  () => [
    { no: 1, name: "rates", kind: "message", T: MetalCuttingRate, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.SetCuttingRatesResponse
 */
export const SetCuttingRatesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SetCuttingRatesResponse",
  () => [
    { no: 1, name: "rates", kind: "message", T: MetalCuttingRate, repeated: true },
  ],
);

